import { type UserInfo, type UserState } from 'types/api/companies/users'
import { capitalize } from 'utils/strings'

import type { UserMember } from 'types/api/users/members'
import type { UserSession } from 'types/api/users/sessions/user-session'

export function createInitials(name = '') {
  const splitName = name.split(' ')
  return splitName
    .filter((part, i, list) => {
      return part.length && (i === 0 || i === list.length - 1)
    })
    .map((s) => s.trim().charAt(0))
    .join('')
    .toUpperCase()
}

export function getUserDisplayName(user?: UserInfo | UserMember | UserSession) {
  return (
    ([user?.first_name, user?.last_name].filter(Boolean).join(' ').trim() ||
      user?.identifier) ??
    ''
  )
}

export function getUserInitials(user?: UserInfo | UserMember) {
  return createInitials(getUserDisplayName(user))
}

/** UserState is in different casing between companies and users endpoints */
export function getIsUserStatus(
  user: UserInfo | UserMember,
  status: UserState
) {
  return user?.state?.toUpperCase() === status
}

export function formatUserStatus(userStatus: string) {
  return capitalize(userStatus)
}

export const formatUserDetails = (
  identifier: string,
  firstName?: string,
  lastName?: string
) => {
  return firstName && lastName
    ? `${firstName} ${lastName} (${identifier})`
    : firstName
    ? `${firstName} (${identifier})`
    : lastName
    ? `${lastName} (${identifier})`
    : identifier
}
